// extracted by mini-css-extract-plugin
export default {"sizeGuide":"MultiOptionsSelector_sizeGuide__2oNYd"};